import * as actionTypes from "../ActionTypes";

const initialState = {
  saleData: [],
  purchaseData: [],
  expenseData: [],
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SALE_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_SALE_SUCCESS:
      return {
        ...state,
        saleData: action.payload,
      };
    case actionTypes.GET_SALE_FAIL:
      return {
        ...state,
        error: "",
      };

    case actionTypes.GET_PURCHASE_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_PURCHASE_SUCCESS:
      return {
        ...state,
        purchaseData: action.payload,
      };
    case actionTypes.GET_PURCHASE_FAIL:
      return {
        ...state,
        error: "",
      };

    case actionTypes.GET_EXPENSE_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_EXPENSE_SUCCESS:
      return {
        ...state,
        expenseData: action.payload,
      };
    case actionTypes.GET_EXPENSE_FAIL:
      return {
        ...state,
        error: "",
      };

    default:
      return state;
  }
};

export default store;
